<template>
    <vue-select
        :value="value"
        @input="handleInput"
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
        @search="fetchOptionsDebounced"
        @open="fetchOptions($attrs.value)"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på kund</em>
        </template>
    </vue-select>
</template>
<script>
import VueSelect from '@components/Wrappers/VueSelect';
import debounce from 'lodash/debounce';
import apiClient from '@services/ApiClient';

export default {
    name: 'CardOrderFilter',
    components: {
        VueSelect,
    },
    props: {
        value: null,
        customerId: {
            type: Number,
            default: null,
        },
        withTemplateView: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            options: [],
            fetchOptionsDebounced: debounce((search) => {
                this.fetchOptions(search);
            }, 200),
        };
    },
    created() {
        this.fetchOptions(this.$attrs.value);
    },
    beforeUnmount() {
        this.fetchOptionsDebounced.cancel();
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
        async fetchOptions(search = '') {
            const url = '/vue/cardorders/list?per_page=20&status_id=all&search=' + search
                + '&customer_id=' + (this.customerId > 0 ? this.customerId : '')
                + '&with_template_view=' + (this.withTemplateView ? '1' : '');
            await apiClient.get(url).then((response) => {
                this.options = response.data.data.map((item) => ({
                    id: item.OrderID,
                    label: '#' + item.OrderID + (item.CustomerRefNo ? ' (' + item.CustomerRefNo + ')' : ''),
                }));
            });
        },
    },
};
</script>
